export default __webpack_public_path__ + "static/media/not_found.0791275b.svg";